import { actions as _act } from '@/models/store.actions';
import store from '@/store/store';
import { globalSettingsHelper } from './settings-helper';
import { permissionsHelper } from '@/helpers/permissions.helper';
import { EventBus } from '@/helpers/event-bus';

class UserModulesHelper {
  get userActions(): Array<number> {
    return store.getters[_act.AUTH_GET_ACTIONSGET] || [];
  }
  get userModules(): Array<string> {
    return store.getters[_act.AUTH_GET_USERMODULES] || [];
  }
  get orgModules(): Array<string> {
    return store.getters[_act.AUTH_GET_ORGMODULES] || [];
  }
  get isCanUseModules(): boolean {
    return globalSettingsHelper.isModulesEnabled && permissionsHelper.isAllowedToViewModules;
  }
  get isCanActivateModules(): boolean {
    return globalSettingsHelper.isModulesEnabled && permissionsHelper.isAllowedToActivateModules;
  }
  isModuleActivated(moduleCode: string): boolean {
    return this.userModules.includes(moduleCode);
  }
  isModuleActivatedForOrganisation(moduleCode: string): boolean {
    return this.orgModules.includes(moduleCode);
  }
  refreshActivatedModules(): Promise<void> {
    return store.dispatch(_act.AUTH_ACT_REFRESHTOKEM).then(() => {
      EventBus.$emit('rebuild-navigation');
    });
  }
}

export const userModulesHelper = new UserModulesHelper();
